import React, {useEffect} from "react";
import "./style.css";
import {Price} from "../Price/Price";
import {getSKUS} from "../../../../../../config/config";

import { Image } from "../../../../../../components/Image";
export const PayWrapper = ({time, timeInSeconds, scrollToBottom, setShowPopup, sku, curPriceIndex, showSkuModule = true, ...props}) => {

  const renderWeek = () => {
    const price = sku.prices[curPriceIndex];
    const finalWeek = price.getFinalWeek();
    return finalWeek === 1 ? "week" : `${finalWeek} weeks`;
  }

  const getRegularSku = () => {
    return getSKUS()?.[0];
  }

  return (
    <div className="pay-wrapper">
      <div className="plan-container-4">
        <p className="plan-title-5">
          Grab your Personal Plan
          <br />
          before it&#39;s gone!
        </p>

        {timeInSeconds > 0 && (
          <div className="offer-info-2">
            <div className="vector-wrapper">
              <Image src="/static/image/questionnaire/weight-loss/payScreen/vector-313-1.svg" alt="Vector" className="vector-2" />
            </div>

            <p className="offer-text-2">This offer ends in {time} min</p>
          </div>
        )}
      </div>

      {showSkuModule && <Price sku={sku} curPriceIndex={curPriceIndex} {...props} />}

      <div className="download-3">
        <div className="money-back-guarantee-2" onClick={scrollToBottom}>
          30 Day Money-Back Guarantee
        </div>
        
        <button className="button-2 btn-ripple" onClick={() => {setShowPopup(true)}}>
          <div className="button-text-3">Get my plan</div>
        </button>
      </div>
      <div className="frame-18">
        <p className="disclaimer-text-2">
          <span className="text-wrapper-7">
            By clicking Get My Plan, I agree that my subscription will be auto-renewed at the full price of <span > {getRegularSku().prices[curPriceIndex].getFinalPrice()} </span> every <span > {renderWeek()} </span> after the intro plan unless I cancel by emailing website@caloapp.ai.
          </span>

        </p>
      </div>

    </div>
  );
};
